module.exports = __webpack_public_path__ + "static/img/Robert-Toia.cf4e64a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Robert-Toia.jpg
// module id = Si3A
// module chunks = 0